import React, { Component } from 'react';
import ReactYandexShare from 'react-yandex-share';

import PageMeta from '@interfaces/page-meta';

export interface StateProps {
    pageMeta: PageMeta;
}

const shareTheme = {
    services: 'vkontakte,facebook,linkedin,twitter,telegram,gplus',
    size: 'm',
    counter: true,
    lang: 'en'
};

class Share extends Component<StateProps> {
    public shouldComponentUpdate() {
        return true;
    }

    public render() {
        const content = {
            ...this.props.pageMeta,
            url: window.location.href
        };

        return (
            <ReactYandexShare
                content={content}
                theme={shareTheme}
            />
        );
    }
}

export default Share;
